import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import { ClientTable } from 'v-tables-3';
import App from './App';
import router from './router';
import store from './store';

import './styles/index.scss';

createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .use(ClientTable, {
    sortIcon: {
      base: 'fa',
      up: 'fa-sort-asc',
      down: 'fa-sort-desc',
      is: 'fa-sort',
    },
  }, 'bootstrap4')
  .mount('#app');
